<template>
    <div id="app">
        <router-view :key="$store.state.version"/>
    </div>
</template>

<script>
export default {
    components: {
    }
};
</script>
